import {
  listProjectMembers,
  searchAssignableUsers,
  setProjectMemberRole,
} from '../../api/projectMembers';
import { isAlreadyMember, SELF_MEMBER_ID } from './memberLabels';
import { ProjectMember } from './types';

async function assignDraftMember(
  projectId: string,
  draft: ProjectMember,
  existingMembers: ProjectMember[],
) {
  const email = draft.email.trim().toLowerCase();
  const candidates = await searchAssignableUsers(projectId, email);
  const user = candidates.find(
    candidate => candidate.email.toLowerCase() === email,
  );
  if (!user) {
    throw new Error(`No organization user with email ${email}`);
  }
  // The creator is already a member when this runs. Setting a role for them
  // would replace their Owner role as soon as the backend uses one id per person.
  if (isAlreadyMember(existingMembers, user)) return;
  await setProjectMemberRole(projectId, user.id, draft.role);
}

export async function assignInitialMembers(
  projectId: string,
  drafts: ProjectMember[],
): Promise<ProjectMember[]> {
  const pending = drafts.filter(draft => draft.id !== SELF_MEMBER_ID);
  if (pending.length === 0) return [];

  let existingMembers: ProjectMember[];
  try {
    existingMembers = await listProjectMembers(projectId);
  } catch {
    return pending;
  }

  const outcomes = await Promise.allSettled(
    pending.map(draft => assignDraftMember(projectId, draft, existingMembers)),
  );
  return pending.filter((_, index) => outcomes[index].status === 'rejected');
}
